// The booking page: pick a slot on the firm's own calendar. Copy is authored
// natively per locale for the ICP reader; no doctrine language here.

const bookingContent = {
  'en-US': {
    seo: {
      title: 'Book a conversation | Lean it 101',
      description: 'Pick a time that works and get thirty minutes with Lean it 101. No email ping-pong.',
    },
    hero: {
      kicker: 'Book a conversation',
      headline: 'Thirty minutes, straight on the calendar.',
      body: 'Pick a time that works for you. You get a calendar invite with a Meet link the moment you confirm.',
    },
    labels: {
      loading: 'Checking the calendar...',
      unavailable: 'Direct booking is offline right now.',
      unavailableCta: 'Open a card on our board instead',
      timezoneNote: 'Times shown in your timezone',
      refresh: 'Show fresh times',
      calendar: { prev: 'Previous month', next: 'Next month', pickDay: 'Pick a day with an opening', dayTimes: 'Openings on' },
      form: {
        name: 'Your name',
        email: 'Work email',
        company: 'Company',
        notes: 'Anything we should read before the call? (optional)',
        submit: 'Confirm the time',
        sending: 'Confirming...',
        required: 'Name and email make the invite work.',
        expired: 'That time just went stale. Pick again from the fresh list.',
        error: 'That did not go through. Try again, or write to contact@leanit101.com.',
      },
      done: {
        title: 'It is on the calendar.',
        body: 'The invite is on its way to your inbox.',
        meet: 'Open the Meet link',
        talk: 'Add context for the call',
      },
    },
  },
  'pt-BR': {
    seo: {
      title: 'Agendar uma conversa | Lean it 101',
      description: 'Escolha um horário e garanta trinta minutos com a Lean it 101. Sem pingue-pongue de email.',
    },
    hero: {
      kicker: 'Agendar uma conversa',
      headline: 'Trinta minutos, direto na agenda.',
      body: 'Escolha o horário que funciona para você. O convite chega com link do Meet assim que você confirmar.',
    },
    labels: {
      loading: 'Consultando a agenda...',
      unavailable: 'O agendamento direto está fora do ar agora.',
      unavailableCta: 'Abrir um cartão no nosso quadro',
      timezoneNote: 'Horários no seu fuso',
      refresh: 'Ver horários atualizados',
      calendar: { prev: 'Mês anterior', next: 'Próximo mês', pickDay: 'Escolha um dia com horário aberto', dayTimes: 'Horários em' },
      form: {
        name: 'Seu nome',
        email: 'Email de trabalho',
        company: 'Empresa',
        notes: 'Algo que devemos ler antes da conversa? (opcional)',
        submit: 'Confirmar o horário',
        sending: 'Confirmando...',
        required: 'Nome e email fazem o convite funcionar.',
        expired: 'Esse horário acabou de vencer. Escolha de novo na lista atualizada.',
        error: 'Não foi dessa vez. Tente de novo, ou escreva para contact@leanit101.com.',
      },
      done: {
        title: 'Está na agenda.',
        body: 'O convite está a caminho do seu email.',
        meet: 'Abrir o link do Meet',
        talk: 'Mandar contexto para a conversa',
      },
    },
  },
  es: {
    seo: {
      title: 'Agendar una conversación | Lean it 101',
      description: 'Elige un horario y asegura treinta minutos con Lean it 101. Sin ping-pong de correos.',
    },
    hero: {
      kicker: 'Agendar una conversación',
      headline: 'Treinta minutos, directo en el calendario.',
      body: 'Elige el horario que te funcione. La invitación llega con enlace de Meet en cuanto confirmes.',
    },
    labels: {
      loading: 'Consultando el calendario...',
      unavailable: 'La reserva directa está fuera de línea ahora.',
      unavailableCta: 'Abrir una tarjeta en nuestro tablero',
      timezoneNote: 'Horarios en tu zona horaria',
      refresh: 'Ver horarios actualizados',
      calendar: { prev: 'Mes anterior', next: 'Mes siguiente', pickDay: 'Elige un día con horario abierto', dayTimes: 'Horarios el' },
      form: {
        name: 'Tu nombre',
        email: 'Email de trabajo',
        company: 'Empresa',
        notes: '¿Algo que debamos leer antes de la llamada? (opcional)',
        submit: 'Confirmar el horario',
        sending: 'Confirmando...',
        required: 'Nombre y email hacen funcionar la invitación.',
        expired: 'Ese horario acaba de vencer. Elige de nuevo en la lista actualizada.',
        error: 'No pasó. Intenta de nuevo, o escribe a contact@leanit101.com.',
      },
      done: {
        title: 'Está en el calendario.',
        body: 'La invitación va en camino a tu correo.',
        meet: 'Abrir el enlace de Meet',
        talk: 'Enviar contexto para la llamada',
      },
    },
  },
}

export const getBookingContent = (language) => {
  if (!language) return bookingContent['en-US']
  if (language.startsWith('pt')) return bookingContent['pt-BR']
  if (language.startsWith('es')) return bookingContent.es
  return bookingContent['en-US']
}

export default bookingContent
